import IMask from 'imask';

export class MaskPattern {
    constructor(mask) {
        this._mask = mask;
        this._unmask = true;
        this._definition = undefined;
        this._lazy = undefined;
        this._placeholder_char = undefined;
        this._blocks = undefined;
    }

    masked(value = true) {
        this._unmask = !value
        return this;
    }

    definition(value){
        this._definition = value;
        return this;
    }

    showPlaceholder(placeholder_char = '_'){
        this._lazy = false;
        this._placeholder_char = placeholder_char;
        return this;
    }

    blocks(value){
        this._blocks = value;
        return this;
    }

}

